import { dbh_ajax } from "Ressources/dbh_ajax";
import { dbh_helper } from "Ressources/dbh_helper";
import { dbh_suchergebnis } from "../Controls/dbh_suchergebnis";
import { dbh_custom_validation } from "../ClientValidation/dbh_custom_validation";
import { cwd } from "process";

if (dbh_helper.getUrlArea() == "belegungen") {
    $("#dbh_Sachkostenblatt").ready(function () {
        if ($("#dbh_Sachkostenblatt") && $("#dbh_Sachkostenblatt").length > 0) {
            let id = dbh_helper.getUrlParameter("id");
            if (id != "") {

                BindTableBtns(id);
                dbh_helper.OnSetDefaultFormValues = () => {
                    BindTableBtns(id);
                };
            }
        }

        $("#addStandard").on("click", function () {
            const belBetId = $(this).data("id");
            if (belBetId) {

                new dbh_ajax().sendGetRequest({
                    actionName: 'AddSachkostenStandardPopup',
                    controllerName: "Belegungen",
                    parameter: [
                        ["id", belBetId]
                    ],
                    callbackSuccess: (ajaxResult: any) => {
                        $("#popup-standardPlaceholder").html(ajaxResult.responseText);

                        $("#newStandardSaveBtn").off("click");
                        $("#newStandardSaveBtn").on("click", function (e) {
                            const form = dbh_helper.findNearestForm(e.currentTarget);

                            let dbhCustomValidation = new dbh_custom_validation();
                            if (dbhCustomValidation.validateForm(form)) {

                                new dbh_ajax().sendPostRequest({
                                    csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                                    controllerName: "Belegungen",
                                    actionName: 'SachkostenstandardAnlegen',
                                    parameter: dbh_helper.getParameterStringForForm(form),
                                    callbackSuccess: (ajaxResult: any) => {
                                        if (ajaxResult != null && ajaxResult != undefined && ajaxResult.responseText != null && ajaxResult.responseText != undefined && ajaxResult.responseText.length > 0) {
                                            $("#newStandardError").html(`<span>${ajaxResult.responseText}</span>`);
                                        }
                                        else {
                                            new dbh_suchergebnis().defaultReloadSearchResult($('.dbhSuchergebnis.SachkostenblattSachkostenModel').first().get(0));
                                            //@ts-ignore
                                            window.hidePopup('SachkostenstandardPopupViewComponent');
                                        }
                                    },
                                    callbackError: (ajaxResult: object) => {

                                    }
                                });
                            }
                        });

                        $("#RefinanzierungZimmerString").on("keyup change", function () {
                            refinanzierungsFunction(this, "#RefinanzierungAlternativString");
                        });

                        $("#RefinanzierungAlternativString").on("keyup change ", function () {
                            refinanzierungsFunction(this, "#RefinanzierungZimmerString");
                        });

                        $("#hidePopup").off("click");
                        $("#hidePopup").on("click", function () {
                            //@ts-ignore
                            window.hidePopup('SachkostenstandardPopupViewComponent');
                        });

                        $("#newStandardCancel").off("click");
                        $("#newStandardCancel").on("click", function () {
                            //@ts-ignore
                            window.hidePopup('SachkostenstandardPopupViewComponent');
                        });

                        //@ts-ignore
                        window.showPopup('SachkostenstandardPopupViewComponent');
                    },
                    callbackError: (ajaxResult: object) => {

                    }
                });
            }
        });
    });

    $("#dbh_SachkostenDetails").ready(function () {
        if ($("#dbh_SachkostenDetails") && $("#dbh_SachkostenDetails").length > 0) {
            let $betrag = $("#BetragString.disabled");
            if ($betrag.length > 0) {
                /*Es handelt sich um Taschen- bzw. Bekleidungsgeld -> Betrag wird automatisch nach Datum berechnet*/
                $("#Von").off("change");
                $("#Von").on("change", function () {
                    const curDateVon = $(this).val();
                    if (curDateVon !== undefined && curDateVon !== null && curDateVon.toString().length > 0) {
                        new dbh_ajax().sendGetRequest({
                            actionName: 'GetTGBGBetrag',
                            controllerName: "Belegungen",
                            parameter: [
                                ["pk_jugendlicher", $("#FK_Jugendlicher").val().toString()],
                                ["dateAb", curDateVon.toString()],
                                ["leistung", $('#Leistung').val().toString()]
                            ],
                            callbackSuccess: (ajaxResult: any) => {
                                try {
                                    $betrag.text(ajaxResult.responseJSON.toString().replace(".", ","));
                                    $betrag.val(ajaxResult.responseJSON.toString().replace(".", ","));
                                } catch (e) {
                                    console.log(e);
                                }
                            },
                            callbackError: (ajaxResult: object) => {
                                $betrag.val("");
                                $betrag.text("");
                            }
                        });
                    }
                })
            }

            dbh_helper.setDefaultFormValues();
        }
    });
}

const refinanzierungsFunction = (elem, idWithHashToChange) => {
    const val = $(elem).val();
    const elemToChange = $(idWithHashToChange);
    if (val.toString().trim().length > 0 && +val !== 0) {
        elemToChange.val("");
        elemToChange.attr('disabled', 'disabled');
    } else {
        elemToChange.removeAttr('disabled');
    }
};

const BindTableBtns = (id) => {
    $('.btnLoeschen').off("click");
    $('.btnLoeschen').on('click', function (e) {

        const $suchergebnisParent = $(this).closest(".dbhSuchergebnis").first().get(0);
        new dbh_ajax().sendGetRequest({
            actionName: "GetSachkostenEntfernenPopupView",
            controllerName: "Belegungen",
            parameter: [["idSk", $(e.target).attr('data-id')], ["idBb", dbh_helper.getUrlParameter("id")]],
            callbackSuccess: (ajaxResult: any) => {
                $('#popup-placeholder').html(ajaxResult.responseText);
                const popupId = $(e.target).attr('data-popup-id');
                (window as any).showPopup(popupId);

                $("#popup-placeholder").ready(function () {
                    $('#btnPrimarySachkostenEntfernen').on('click', (e) => {
                        var form = dbh_helper.findNearestForm(e.target);
                        new dbh_ajax().sendPostRequest({
                            csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                            actionName: "SachkostenEntfernen",
                            controllerName: "Belegungen",
                            parameter: dbh_helper.getParameterStringForForm(form),
                            callbackSuccess: (ajaxResult: any) => {
                                //window.location.reload();
                                (window as any).hidePopup(popupId);
                                new dbh_suchergebnis().defaultReloadSearchResult($suchergebnisParent);

                            },
                            callbackError: (ajaxResult: any) => {

                                $('#dbhErrorSachkostenEntfernen').html(ajaxResult.responseJSON.message).show();
                            }
                        });

                        e.stopPropagation();
                    });
                });
            },
            callbackError: (ajaxResult: object) => {
            }
        });

        e.stopPropagation();
    });

    $('.btnBeenden').off("click");
    $('.btnBeenden').on('click', function (e) {
        const $suchergebnisParent = $(this).closest(".dbhSuchergebnis").first().get(0);

        new dbh_ajax().sendGetRequest({
            actionName: "GetSachkostenBeendenPopupView",
            controllerName: "Belegungen",
            parameter: [["idSk", $(e.target).attr('data-id')], ["idBb", dbh_helper.getUrlParameter("id")]],
            callbackSuccess: (ajaxResult: any) => {
                $('#popup-placeholder').html(ajaxResult.responseText);
                const popupId = $(e.target).attr('data-popup-id');
                (window as any).showPopup(popupId);

                $("#popup-placeholder").ready(function () {
                    $('#btnPrimarySachkostenBeenden').on('click', (e) => {
                        var form = dbh_helper.findNearestForm(e.target);

                        new dbh_ajax().sendPostRequest({
                            csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                            actionName: "SachkostenBeenden",
                            controllerName: "Belegungen",
                            parameter: dbh_helper.getParameterStringForForm(form),
                            callbackSuccess: (ajaxResult: any) => {
                                (window as any).hidePopup(popupId);
                                new dbh_suchergebnis().defaultReloadSearchResult($suchergebnisParent);
                            },
                            callbackError: (ajaxResult: any) => {
                                $('#dbhErrorSachkostenBeenden').html(ajaxResult.responseJSON.message).show();
                            }
                        });

                        e.stopPropagation();
                    });
                });
            },
            callbackError: (ajaxResult: object) => {
            }
        });

        e.stopPropagation();
    });
}